import { styled } from '@compiled/react';

import Image from '@atlaskit/image';
import { token } from '@atlaskit/tokens';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const CommonErrorStateWrapper = styled.div<{
	itemHeight: number;
	isInViewMode: boolean;
	isHero?: boolean;
	isNavigationThumbnail?: boolean;
	isSelected?: boolean;
	isVerticalHero?: boolean;
	minWidth?: number;
}>({
	display: 'flex',
	borderRadius: token('space.100'),
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	boxShadow: ({ isNavigationThumbnail, isHero }) =>
		isNavigationThumbnail || isHero ? 'none' : token('elevation.shadow.raised'),
	backgroundColor: token('color.background.input'),
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	...({ minWidth }) =>
		minWidth && {
			// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
			minWidth: `${minWidth}px`,
		},
	overflow: 'hidden',
	//subtracting [borderTop/Bottom] for the border height being added in heroframe
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	height: ({ itemHeight, isHero, isNavigationThumbnail }) =>
		isHero || isNavigationThumbnail ? `${itemHeight - 2}px` : `${itemHeight}px`,
	marginTop: token('space.0'),
	marginLeft: token('space.0'),
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	border: ({ isSelected, isNavigationThumbnail, isHero }) =>
		isSelected
			? `${token('border.width')} ${token('color.border.selected')} solid`
			: isNavigationThumbnail || isHero
				? ` ${token('border.width')} ${token('color.border')} solid`
				: 'none',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	...({ isInViewMode, isHero, isNavigationThumbnail }) =>
		isInViewMode && {
			'&:hover': {
				boxShadow:
					isHero || isNavigationThumbnail ? 'none' : `0px 5px 12px 0px ${token('color.border')}`,
				cursor: isHero ? 'cursor' : 'pointer',
			},
		},
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	flexDirection: ({ isHero, isVerticalHero }) => (isHero && isVerticalHero ? 'column' : 'initial'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const ErrorStateContainer = styled(CommonErrorStateWrapper)({
	alignItems: 'center',
	justifyContent: 'center',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const SmallErrorStateImage: any = styled(Image)({
	borderTopLeftRadius: '7px',
	borderBottomLeftRadius: '7px',
	backgroundColor: token('color.background.accent.gray.subtlest'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const SmallErrorStateTextWrapper = styled.div({
	display: 'flex',
	flexDirection: 'column',
	paddingTop: token('space.200'),
	paddingRight: token('space.200'),
	paddingBottom: token('space.200'),
	paddingLeft: token('space.200'),
	alignSelf: 'center',

	font: token('font.body'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const SmallErrorStateHeading = styled.span({
	fontWeight: token('font.weight.medium'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const ErrorStateSubheading = styled.div<{ size?: string }>({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	...({ size }) =>
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
		size !== 'small' && {
			padding: `${token('space.0')} ${token('space.300')}`,
			marginBottom: token('space.200'),
		},
	color: token('color.text.subtlest'),

	font: token('font.body'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const ErrorStateSmallLink = styled.a({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
	color: `${token('color.text.subtle')} !important`,
});
